document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    changeBackgroundColor();
    formatReviewsQuantity();
    moveDateToBottom();
  }, 1000);
});

function changeBackgroundColor() {
  const section = document.querySelector(".jdgm-rev-widg").closest("section");
  if (!section) return;

  section.style.backgroundColor = "#fff";
}

function formatReviewsQuantity() {
  const reviewsQuantity = document.querySelector(
    ".jdgm-rev-widg__summary-average"
  );
  if (!reviewsQuantity) return;

  const text = reviewsQuantity.textContent;
  const formatedText = `(${text.split("out of ")[1].trim()})`;

  reviewsQuantity.textContent = formatedText;
}

function moveDateToBottom() {
  const dates = document.querySelectorAll(".jdgm-rev__timestamp");
  if (!dates.length === 0) return;

  dates.forEach((date) => {
    const parent = date.closest(".jdgm-rev");
    date.style.display = "block";
    date.style.float = "left";
    parent.appendChild(date);
  });
}
